import { RouteNames } from '../../types/RouteNames'

const withBackofficeBaseRoute = <T extends string>(path: T) =>
  `/backoffice${path}` as const

export const backofficeRouteNames = {
  home: withBackofficeBaseRoute(''),
  profile: withBackofficeBaseRoute('/profile'),
  dashboard: withBackofficeBaseRoute('/dashboard'),
  bodyInspectionAreas: withBackofficeBaseRoute('/body-inspection-areas'),
  bodyInspectionPoints: withBackofficeBaseRoute('/body-inspection-points')
} as const satisfies RouteNames
